import React, { useState, useRef, useEffect } from "react";
import { LuDownload } from "react-icons/lu";
import {
  exportToExcel,
  exportToPDF,
  exportToText,
} from "../../../../utils/exportChatLogs";

const ExportChatButton = ({ cons }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleExport = (type) => {
    switch (type) {
      case "pdf":
        exportToPDF(cons);
        break;
      case "text":
        exportToText(cons);
        break;
      case "excel":
        exportToExcel(cons);
        break;
      default:
        break;
    }
    setOpen(false);
  };

  return (
    <div className="relative inline-block w-full mb-4" ref={dropdownRef}>
      <button
        className="flex items-center justify-center w-full gap-2 px-4 py-2 border rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700"
        title="Export Chat Logs"
        onClick={() => setOpen(!open)}>
        <LuDownload /> Export
      </button>

      {open && (
        <div className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-md">
          <button
            className="block w-full px-4 py-2 text-left hover:bg-gray-100"
            onClick={() => handleExport("pdf")}>
            Export as PDF
          </button>
          <button
            className="block w-full px-4 py-2 text-left hover:bg-gray-100"
            onClick={() => handleExport("text")}>
            Export as Text
          </button>
          <button
            className="block w-full px-4 py-2 text-left hover:bg-gray-100"
            onClick={() => handleExport("excel")}>
            Export as Excel
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportChatButton;
